import { render, staticRenderFns } from "./mpyy1.vue?vue&type=template&id=e1cd3b06&scoped=true&"
import script from "./mpyy1.vue?vue&type=script&lang=js&"
export * from "./mpyy1.vue?vue&type=script&lang=js&"
import style0 from "./mpyy1.vue?vue&type=style&index=0&id=e1cd3b06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cd3b06",
  null
  
)

export default component.exports